/* SpawnAnything — slim top strip on phones (user decision 02.10.2026: "Schlank + Menü"). On narrow screens the header
   keeps the main-menu button and the score; campaign, crates/diamonds and multiplayer move behind a ☰ button whose
   menu simply clicks the original buttons (they keep their ids, listeners and labels). */
import './topMenu.css';

export function initTopMenu() {
  const top = document.querySelector('header.top'); if (!top) return null;
  const btn = document.createElement('button');
  btn.type = 'button'; btn.className = 'top-menu-btn'; btn.setAttribute('aria-haspopup', 'menu'); btn.setAttribute('aria-expanded', 'false');
  btn.setAttribute('aria-label', 'Menü'); btn.innerHTML = '<i class="ti ti-menu-2" aria-hidden="true"></i>';
  const menu = document.createElement('div'); menu.className = 'top-menu'; menu.hidden = true; menu.setAttribute('role', 'menu');
  top.appendChild(btn); document.body.appendChild(menu);
  // the original header buttons, read when the menu opens (some are created later by their features)
  const items = () => [
    ['.campaign-btn', 'ti-map-2', () => `Kampagne ${document.querySelector('.campaign-btn b')?.textContent || ''}`],
    ['#crateBtn', 'ti-diamond', () => `Kisten · ${document.querySelector('#diaBal')?.textContent || 0} Diamanten`],
    ['.mpbtn', 'ti-users', () => (document.querySelector('.mpbtn')?.textContent || 'Mehrspieler').trim()],
  ].filter(([sel]) => document.querySelector(sel));
  function render() {
    menu.innerHTML = items().map(([sel, icon, label], k) => `<button type="button" role="menuitem" data-k="${k}"><i class="ti ${icon}" aria-hidden="true"></i> ${label()}</button>`).join('');
  }
  const set = on => { menu.hidden = !on; btn.setAttribute('aria-expanded', String(on)); if (on) render(); };
  btn.addEventListener('click', e => { e.stopPropagation(); set(menu.hidden); });
  menu.addEventListener('click', e => {
    const b = e.target.closest('[data-k]'); if (!b) return;
    const it = items()[+b.dataset.k]; set(false);
    document.querySelector(it[0])?.click();
  });
  addEventListener('pointerdown', e => { if (!menu.hidden && !menu.contains(e.target) && e.target !== btn && !btn.contains(e.target)) set(false); }, true);
  addEventListener('keydown', e => { if (e.code === 'Escape' && !menu.hidden) { e.preventDefault(); set(false); } }, true);
  return { close: () => set(false) };
}
